var swiper = new Swiper(".mySwiper", {
  spaceBetween: 0,
  slidesPerView: "auto",
  centeredSlides: false,
  loop: false,
  grabCursor: true,
  observer: true,
  freeMode: true,
  observeParents: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  keyboard: {
    enabled: true,
  },
});

var swiper = new Swiper(".subcategory_slider", {
  spaceBetween: 0,
  slidesPerView: "auto",
  centeredSlides: false,
  loop: true,
  grabCursor: true,
  observer: true,
  freeMode: false,
  observeParents: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  keyboard: {
    enabled: true,
  },
});

var swiper = new Swiper(".mySwiper-tab", {
  spaceBetween: 0,
  slidesPerView: "auto",
  centeredSlides: true,
  loop: true,
  grabCursor: true,
  observer: true,
  freeMode: false,
  observeParents: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  keyboard: {
    enabled: true,
  },
});

setTimeout(function () {
  var swiper = new Swiper(".related-slider", {
    spaceBetween: 0,
    slidesPerView: "auto",
    loop: false,
    grabCursor: true,
    observer: true,
    freeMode: false,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      0: {
        centeredSlides: true,
      },
      767: {
        centeredSlides: false,
      },
    },
    keyboard: {
      enabled: true,
    },
  });
}, 2500);

var swiper = new Swiper(".testimonial-slide", {
  spaceBetween: 25,
  slidesPerView: 1,
  centeredSlides: false,
  initialSlide: 0,
  loop: true,
  grabCursor: true,
  observer: true,
  freeMode: false,
  observeParents: true,
  autoplay: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  arrows: false,

  /* autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
    navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },*/

  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  keyboard: {
    enabled: true,
  },
  breakpoints: {
    900: {
      slidesPerView: 2,
    },
  },
});

$(".collection-tab .collection-tab-heading").on("click", function (e) {
  $(this)
    .closest(".collection-tab")
    .find(".collection-tab-heading")
    .removeClass("is-active");
  $(this).addClass("is-active");
  var id = $(this).data("id");
  $(this)
    .closest(".page-width-slider")
    .find('.collection-tab-content[data-id="' + id + '"]')
    .addClass("tab-active");
  $(this)
    .closest(".page-width-slider")
    .find('.collection-tab-content[data-id!="' + id + '"]')
    .removeClass("tab-active");
});

$(document).ready(function () {
  testimonail_height();
  $(document).on("change", ".shopify-localization-form select", function (e) {
    var _this = $(this);
    setTimeout(function (e) {
      _this.closest("form").submit();
    }, 300);
  });
  $(".sticky_cart_ctm").on("click", function (params) {
    $("product-form .product-form__buttons .product-form__submit")[0].click();
  });
});

$(window).resize(function () {
  testimonail_height();
});

$(window).on("load", function () {
  testimonail_height();
});

function testimonail_height() {
  var heightarray = new Array();
  $(".testimonial-item-bg .testimonial-content").removeAttr("style");
  $(".testimonial-item-bg .testimonial-content").each(function () {
    var height = $(this).outerHeight();
    heightarray.push(height);
  });
  var maxheight = Math.max.apply(Math, heightarray);
  $(".testimonial-item-bg .testimonial-content").height(maxheight);
}

$(document).on("click", ".filter-bar-top-right ul li", function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  if ($(this).hasClass("list-view")) {
    $("body").removeClass("grid-view");
    $("body").addClass("list-view");
  }
  if ($(this).hasClass("grid-view")) {
    $("body").removeClass("list-view");
    $("body").addClass("grid-view");
  }
});

$(document).on("click", ".filter-bar-mobile-click", function () {
  $(".mobile-facets__open-wrapper").trigger("click");
});

$(document).ready(function () {
  $(".slider-for-main").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    fade: true,
    asNavFor: ".slider-for-thumbail",
  });

  $(".slider-for-thumbail").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: ".slider-for-main",
    dots: false,
    prevArrow:
      '<button class="slick-prev slick-arrow slider-arrow-ver flex  justify-center" aria-label="Previous" ><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="113px" height="113px" viewBox="0 0 16 16" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" id="svg2" version="1.1" fill="#000" stroke="#000"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><metadata id="metadata7"><rdf:rdf><cc:work><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/><dc:title/><dc:date>2021</dc:date><dc:creator><cc:agent><dc:title>Timothée Giet</dc:title></cc:agent></dc:creator><cc:license rdf:resource="http://creativecommons.org/licenses/by-sa/4.0/"/></cc:work><cc:license rdf:about="http://creativecommons.org/licenses/by-sa/4.0/"><cc:permits rdf:resource="http://creativecommons.org/ns#Reproduction"/><cc:permits rdf:resource="http://creativecommons.org/ns#Distribution"/><cc:requires rdf:resource="http://creativecommons.org/ns#Notice"/><cc:requires rdf:resource="http://creativecommons.org/ns#Attribution"/><cc:permits rdf:resource="http://creativecommons.org/ns#DerivativeWorks"/><cc:requires rdf:resource="http://creativecommons.org/ns#ShareAlike"/></cc:license></rdf:rdf></metadata><g id="layer1" transform="rotate(45 1254.793 524.438)"><path style="fill:#000;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="M15.464 1044.409v-1.997h-9v-9h-2v11z" id="path4179"/></g></g></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow slider-arrow-ver flex  justify-center" style="transform: translateY(-65%) rotateY(180deg)"  aria-label="Next" ><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="113px" height="113px" viewBox="0 0 16 16" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" id="svg2" version="1.1" fill="#000" stroke="#000" ><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><metadata id="metadata7"><rdf:rdf><cc:work><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/><dc:title/><dc:date>2021</dc:date><dc:creator><cc:agent><dc:title>Timothée Giet</dc:title></cc:agent></dc:creator><cc:license rdf:resource="http://creativecommons.org/licenses/by-sa/4.0/"/></cc:work><cc:license rdf:about="http://creativecommons.org/licenses/by-sa/4.0/"><cc:permits rdf:resource="http://creativecommons.org/ns#Reproduction"/><cc:permits rdf:resource="http://creativecommons.org/ns#Distribution"/><cc:requires rdf:resource="http://creativecommons.org/ns#Notice"/><cc:requires rdf:resource="http://creativecommons.org/ns#Attribution"/><cc:permits rdf:resource="http://creativecommons.org/ns#DerivativeWorks"/><cc:requires rdf:resource="http://creativecommons.org/ns#ShareAlike"/></cc:license></rdf:rdf></metadata><g id="layer1" transform="rotate(45 1254.793 524.438)"><path style="fill:#000;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="M15.464 1044.409v-1.997h-9v-9h-2v11z" id="path4179"/></g></g></svg></button>',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  });
});

(function () {
  const days = $(".e-m-days");
  const hours = $(".e-m-hours");
  const minutes = $(".e-m-minutes");
  const seconds = $(".e-m-seconds");
  const ctm_head_timer = $(".ctm_head_timer").attr("data-timer");
  var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var frenchMonthNames = [
    "janvier",
    "fevrier",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "decembre",
  ];
  var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  var frenchDayNames = [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
  ];

  var countDownTimer = setInterval(function () {
    var addDays = 0;
    const currentDate = new Date();
    const cutoffDate = new Date(
      monthNames[currentDate.getMonth()] +
        " " +
        currentDate.getDate() +
        ", " +
        currentDate.getFullYear() +
        " " +
        ctm_head_timer +
        ":00"
    );
    var targetDate = new Date(cutoffDate);
    /* 
  console.log("currentDate:",currentDate);//, "cutoffDate:",cutoffDate);
  console.log("currentDate getDay:",currentDate.getDay())
  */
    if (currentDate.getTime() < cutoffDate.getTime()) {
      addDays = 0; // if time is less then cutoff time on same day then no need to add days
      if (currentDate.getDay() == 5) {
        addDays = 2; // if friday before 2 then set time next monday
      }
    } else {
      if (currentDate.getDay() == 5) {
        // if time is more then cutoff time on friday
        addDays = 3; // if time is more then cutoff time on friday then set timer for monday
      } else if (currentDate.getDay() == 4) {
        addDays = 3; // if Thursday after 2PM then set time next monday
      } else {
        addDays = 1; // if time is more then cutoff time on same day then set next day
      }
    }
    if (currentDate.getDay() == 6) {
      addDays = 2; // if saturday then set time next monday
    }
    if (currentDate.getDay() == 0) {
      addDays = 1; // if sunday then set time next monday
    }

    targetDate.setDate(cutoffDate.getDate() + addDays);
    // console.log("addDays:",addDays);
    //console.log("targetDate:", targetDate);

    function convertMillis(milliseconds, format) {
      var days,
        hours,
        minutes,
        seconds,
        total_hours,
        total_minutes,
        total_seconds;

      total_seconds = parseInt(Math.floor(milliseconds / 1000));
      total_minutes = parseInt(Math.floor(total_seconds / 60));
      total_hours = parseInt(Math.floor(total_minutes / 60));
      days = parseInt(Math.floor(total_hours / 24));

      seconds = parseInt(total_seconds % 60);
      minutes = parseInt(total_minutes % 60);
      hours = parseInt(total_hours % 24);
      if (days > 0) {
        hours = hours + 24 * days;
      }

      switch (format) {
        case "s":
          return total_seconds;
        case "m":
          return total_minutes;
        case "h":
          return total_hours;
        case "d":
          return days;
        default:
          return { d: days, h: hours, m: minutes, s: seconds };
      }
    }

    // Where we check if 'now' is greater than the target date
    // var date = Date.now(); or  new Date("2022-03-25");
    var date = Date.now();

    if (date > targetDate) {
      // Where we break
      console.log("Expired");
      clearInterval(countDownTimer);
      $(".ctm_head_timer").hide();
    } else {
      // Where we set values
      var millis = targetDate - date;
      if (
        (currentDate.getDay() == 4 &&
          currentDate.getTime() > cutoffDate.getTime()) ||
        (currentDate.getDay() == 5 &&
          currentDate.getTime() < cutoffDate.getTime())
      ) {
        let d = new Date(targetDate.getTime() - 86400000 - 86400000);
        var millis = d - date;
        console.log("361");
      }
      var millisObject = convertMillis(millis);

      // Display values in HTML
      days.text(millisObject.d);
      hours.text(millisObject.h);
      minutes.text(millisObject.m);
      seconds.text(millisObject.s);

      // display delivery msg
      var delDate = new Date();
      // delDate.setDate(targetDate.getDate() + 1);
      delDate = new Date(targetDate.getTime() + 86400000);
      //console.log("targetDate", targetDate);
      //console.log("delDate", delDate);
      var showDelMsg = "";
      if (addDays == 0) {
        showDelMsg = "Get it tomorrow";
        if (Shopify.locale == "fr") {
          showDelMsg = "Recevez demain";
        }
      } else {
        if (Shopify.locale == "fr") {
          // showDelMsg = "Recevez "+frenchDayNames[delDate.getDay()] + ", "+frenchMonthNames[delDate.getMonth()]+ " " +delDate.getDate() ;
          showDelMsg =
            "Recevez " +
            frenchDayNames[delDate.getDay()] +
            ", " +
            delDate.getDate() +
            " " +
            frenchMonthNames[delDate.getMonth()];
        } else {
          showDelMsg =
            "Get it " +
            dayNames[delDate.getDay()] +
            ", " +
            monthNames[delDate.getMonth()] +
            " " +
            delDate.getDate();
        }
      }
      $(".e-m-delmsg").text(showDelMsg);
      $(".ctm_head_timer").show();
    }
  }, 1000);
})();

// $('.mp_video_box').click(function(){
// 	// Toggle Magic Here
//   $(".mp_video_box").toggleClass("play_video");
//     this[this.paused ? 'play' : 'pause']();
//     if(this.pause == true){
//       this[play];
//     }else{
//       this[pause];
//     }
// });

// $('.product-nav a').click(function(){
//   let windowWidth = window.innerWidth ;
//   var height = $('sticky-header').outerHeight();
//   if($($(this).attr('href')).offset() != undefined){
//     $('html, body').animate({
//         scrollTop: $($(this).attr('href')).offset().top - height
//     }, 500);
//   }
//   $(this).closest('ul').find('li').removeClass('active');
//   $(this).closest('li').addClass('active');
//   return false;
// });

// $('.pickup ul li').on('click',function(e){
//   $(this).closest('ul').find('li').removeClass('pickup-active');
//   $(this).addClass('pickup-active');
//   var pick_up = $(this).data('pickup');
//   $('.product-form form [name="properties[Ship Type]"]').val(pick_up);
// })

$(".addon-main li .addon-add_cart").on("click", function (e) {
  $(this).toggleClass("addon-add_cart-active");
  var id = $(this).data("id");
  if ($(this).hasClass("addon-add_cart-active")) {
    // $('#addon-popup .addon-main li .addon-add_cart[data-id="'+id+'"]').addClass('addon-add_cart-active');
    $(this).addClass("addon-add_cart-active");
  } else {
    // $('#addon-popup .addon-main li .addon-add_cart[data-id="'+id+'"]').removeClass('addon-add_cart-active');
    $(this).removeClass("addon-add_cart-active");
  }
});

$(document).on("click", "#addon-popup .addon-remove", function (e) {
  var id = parseInt($(this).attr("data-var-id"));
  $.ajax({
    method: "post",
    url: "/cart/change.js",
    data: "id=" + id + "&quantity=0",
    dataType: "json",
    success: function (data) {
      window.location.reload();
    },
    error: function (err) {
      console.log(err);
    },
  });
});
//,#addon-popup .addon-checkout-ctm
$(".buy-now-trigger a ").on("click", function (e) {
  e.preventDefault();
  var id_arr = [];
  var add_i = 0;
  var len = $(
    "#addon-popup .addon-main li .addon-add_cart.addon-add_cart-active"
  ).length;
  if (len > 0) {
    $("#addon-popup .addon-main li .addon-add_cart.addon-add_cart-active").each(
      function (e) {
        id_arr.push($(this).data("id"));
      }
    );
    var form = $(".qty_add_cart .product-form form").serialize();
    $.ajax({
      method: "post",
      url: "/cart/add.js",
      data: form,
      dataType: "json",
      success: function (data) {
        add_to_cart(id_arr);
      },
      error: function (err) {
        add_to_cart(id_arr);
      },
    });
  } else {
    var form = $(".qty_add_cart .product-form form").serialize();
    $.ajax({
      method: "post",
      url: "/cart/add.js",
      data: form,
      dataType: "json",
      success: function (data) {
        window.location.href = "/checkout";
      },
      error: function (err) {
        window.location.reload();
      },
    });
  }
  return false;
});
$("#addon-popup .addon-viewcart-ctm").on("click", function (e) {
  e.preventDefault();
  var id_arr = [];
  var add_i = 0;
  var len = $(
    "#addon-popup .addon-main li .addon-add_cart.addon-add_cart-active"
  ).length;
  if (len > 0) {
    $("#addon-popup .addon-main li .addon-add_cart.addon-add_cart-active").each(
      function (e) {
        id_arr.push($(this).data("id"));
      }
    );
    var form = $(".qty_add_cart .product-form form").serialize();
    $.ajax({
      method: "post",
      url: "/cart/add.js",
      data: form,
      dataType: "json",
      success: function (data) {
        cart_page_add_to_cart(id_arr);
      },
      error: function (err) {
        cart_page_add_to_cart(id_arr);
      },
    });
  } else {
    window.location.href = "/cart";
  }
  return false;
});

var i = 0;
function cart_page_add_to_cart(id_arr) {
  var len = id_arr.length;
  if (i < len) {
    $.ajax({
      method: "post",
      url: "/cart/add.js",
      data: "id=" + id_arr[i] + "&quantity=1",
      dataType: "json",
      success: function (data) {
        i++;
        cart_page_add_to_cart(id_arr);
      },
      error: function (err) {
        console.log(err);
        i++;
        cart_page_add_to_cart(id_arr);
      },
    });
  } else {
    i = 0;
    window.location.href = "/cart";
  }
}

var add_i = 0;
function add_to_cart(id_arr) {
  var len = id_arr.length;
  if (add_i < len) {
    $.ajax({
      method: "post",
      url: "/cart/add.js",
      data: "id=" + id_arr[add_i] + "&quantity=1",
      dataType: "json",
      success: function (data) {
        add_i++;
        add_to_cart(id_arr);
      },
      error: function (err) {
        console.log(err);
        add_i++;
        add_to_cart(id_arr);
      },
    });
  } else {
    add_i = 0;
    window.location.href = "/checkout";
  }
}

let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

$(window)
  .on("scroll", () => {
    $("[touching]").each(function () {
      var className = $(this).attr("touching");
      var offset = $(this).offset().top - $(window).scrollTop();
      if (offset <= 100) {
        $("body").addClass("sticky_active_nav");
      } else {
        $("body").removeClass("sticky_active_nav");
      }
    });
  })
  .trigger("scroll");

if (window.location.href.indexOf("products") > -1) {
  $(document).ready(() => {
    let myMinHeight = $("#page-scroll-content").height();
    $("#page-scroll-container").css({ minHeight: myMinHeight });
  });
}

$(".product-nav ul li a").click(function (e) {
  e.preventDefault();
  var href = $(this).attr("href");
  var headerHeight = 0;
  if (window.innerWidth > 768) {
    headerHeight =
      $(".product-sticky-bar-show").innerHeight() +
      $(".product-nav ul").innerHeight();
  }

  if (window.innerWidth < 768) {
    headerHeight += 80;
  }
  $("html, body").animate(
    {
      scrollTop: $(href).offset().top - headerHeight,
    },
    500
  );
  return false;
});

$(window)
  .on("scroll", () => {
    $(".qty-btn-cover[touching]").each(function () {
      var className = $(this).attr("touching");
      var offset = $(this).offset().top - $(window).scrollTop();
      var height = $(".product-sticky-bar").outerHeight();
      if (offset <= 0) {
        $("body").addClass("sticky_active");
      } else {
        $("body").removeClass("sticky_active");
      }
      if ($(window).width() > 768) {
        if ($(window).width() < 1271) {
          height = height;
        } else {
          if (
            $(
              ".shopify-section-header-sticky:not(.shopify-section-header-hidden)"
            ).length != 0
          ) {
            height =
              height +
              $(
                ".shopify-section-header-sticky:not(.shopify-section-header-hidden) .header-mobile.header"
              ).outerHeight() -
              2;
          }
        }
      } else {
        if (
          $(
            ".shopify-section-header-sticky:not(.shopify-section-header-hidden)"
          ).length != 0
        ) {
          height = $(".header-mobile.header").outerHeight();
        } else {
          height = 0;
        }
      }
      $(".product-nav-border").css("top", height + "px");
    });

    $(".ctm_sticky_tab[touching]").each(function () {
      var className = $(this).attr("touching");
      var offset = $(this).offset().top - $(window).scrollTop();
      if (offset <= 100) {
        $("body").addClass("sticky_active_nav");
      } else {
        $("body").removeClass("sticky_active_nav");
      }
    });

    // var scrollDistance = $(window).scrollTop();
    // console.log(scrollDistance);
    // $('.shopify-section.section').each(function(i,e) {
    //   if ($(this).position().top <= scrollDistance) {
    //     console.log(e);
    //     $('.navigation a.active').removeClass('active');
    //     $('.navigation a').eq(i).addClass('active');
    //   }
    // });

    var addHeight = 0;

    var scrollPos = $(document).scrollTop();
    $(".product-nav ul li a").each(function () {
      var currLink = $(this);
      var refElement = $(currLink.attr("href"));
      if (
        refElement != null &&
        refElement != undefined &&
        refElement.length > 0
      ) {
        if (
          refElement.position().top <= scrollPos + 210 &&
          refElement.position().top + refElement.height() > scrollPos
        ) {
          $(".product-nav ul li").removeClass("active");
          currLink.closest("li").addClass("active");
          addHeight = 30;
        }
      }
    });
  })
  .trigger("scroll");

/*
$(document).ready(function(){
  if($.cookie('czipcode') == undefined){
  $.getJSON("https://ipinfo.io", function(data) {
    //console.log(data);
    if(data.postal != undefined){
      $(".location-city-inner span").text(data.postal);
      $(".location-city-inner").show();
      $.cookie('czipcode', data.postal, { path: '/' });
    }
  });
  }else{
    $(".location-city-inner span").text($.cookie('czipcode'));
    $(".location-city-inner").show();
  }
});
*/

// jQuery must be loaded before calling this function ( for AJAX )
let getUserPostcode = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        let lat = position.coords.latitude,
          long = position.coords.longitude,
          url =
            "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
            lat +
            "," +
            long +
            "&key=AIzaSyCwTU6L7tpSkNybwjtR6c3HxBF_000CtFI";
        $.ajax({
          type: "GET",
          url: url,
          dataType: "json",
          success: function (response) {
            let results = response.results,
              postalCode = "";
            if (results[0]) {
              for (let i = 0; i < results[0].address_components.length; i++) {
                let types = results[0].address_components[i].types;

                for (let typeIdx = 0; typeIdx < types.length; typeIdx++) {
                  if (types[typeIdx] == "postal_code") {
                    postalCode = results[0].address_components[i].long_name;
                    break;
                  }
                }
                if (postalCode !== "") {
                  break;
                }
              }
            }
            //console.log(postalCode);
            $(".location-city-inner span").text(postalCode);
            $(".location-city-inner").show();
          },
          error: function (req, status, error) {
            //console.log("Sorry, there was an error.");
          },
        });
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            //console.log("User denied the request for Geolocation.");
            break;
          case error.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.");
            break;
          case error.TIMEOUT:
            console.log("The request to get user location timed out.");
            break;
          case error.UNKNOWN_ERROR:
            console.log("An unknown error occurred.");
            break;
        }
      }
    );
  } else {
    console.log("Sorry, Geolocation is not supported by your browser.");
  }
};
$(document).ready(function () {
  getUserPostcode();
});

// $(document).ready(function(){
// 	grid_height();
// });

// $(window).resize(function(){
// 	grid_height();
// });

// function grid_height(){
// 	var heightarray = new Array();
//   if($('.card__content-list-right .card__information').length){
// 	$('.card__content-list-right .card__information').removeAttr('style');
// 	$('.card__content-list-right .card__information').each(function() {
//         var height = $(this).outerHeight();
// 		heightarray.push(height);
//     });
// 	var maxheight = Math.max.apply(Math,heightarray);
// 	$('.card__content-list-right .card__information').height(maxheight);
//     }
// }
